import { MatDialog } from '@angular/material/dialog';
import { LogService } from '@pershing/pershing-core';
import { OrderSettingsComponent } from './order-settings.component';
import { Account } from '../../../models/common/trading-common.model';

export function openOrderSettings(isAdmin: boolean, _account: Account, _dialog: MatDialog, _logService: LogService) {
    let isWindowBigSize = window.innerWidth > 1280;
    let dialogWidth = '80%';
    if (isAdmin && isWindowBigSize || (!isAdmin && !isWindowBigSize)) {
        dialogWidth = '60%';
    } else if (!isAdmin && isWindowBigSize) {
        dialogWidth = '40%';
    }
    const orderSettingsDialogRef = _dialog.open(OrderSettingsComponent, {
        panelClass: 'modal',
        disableClose: true,
        autoFocus: false,
        width: dialogWidth,
        data: {
            account: _account
        }
    });

    orderSettingsDialogRef.afterClosed().subscribe((data) => {
        _logService.log('The orderSettingsDialogRef was closed', data);
    });
}
